const getQueryParam = (search: string, key: string) => {
  const query = search.startsWith("?") ? search.slice(1) : search;
  const parameter = query.split("&").find((part) => part.startsWith(`${key}=`));

  if (!parameter) return null;

  return parameter.slice(key.length + 1);
};

const getOpenAppLinkToken = () => {
  const sharedcode = getQueryParam(window.location.search, "sharedcode");
  const acr = getQueryParam(window.location.search, "acr");
  const source = getQueryParam(window.location.search, "source");

  return sharedcode && acr && source ? `sharedcode=${sharedcode}&acr=${acr}&source=${source}` : "";
};

export default getOpenAppLinkToken;
